import { applicationCapabilitiesStore } from "./ApplicationCapabilitiesStore";
import { SUB_CAPABILITY_PARENT_MAP } from "@next-platform/packages-ts-types";
export function isSubCapabilityKey(key) {
    return key in SUB_CAPABILITY_PARENT_MAP;
}
export function getResolvedCapability(key) {
    if (isSubCapabilityKey(key)) {
        const parentKey = SUB_CAPABILITY_PARENT_MAP[key];
        return applicationCapabilitiesStore.getSubCapability(parentKey, key);
    }
    return applicationCapabilitiesStore.getCapability(key);
}
export function getAllowedValue(key) {
    if (isSubCapabilityKey(key)) {
        const parentKey = SUB_CAPABILITY_PARENT_MAP[key];
        return applicationCapabilitiesStore.getSubCapability(parentKey, key)?.allowed ?? false;
    }
    return applicationCapabilitiesStore.getCapabilityShallow(key)?.allowed ?? false;
}
